import { CustomWindow } from '@utils/models/customwindow';
import { useBlockMedia } from "./video";

declare let window: CustomWindow;

// Stage 2: Initialize YouTube
export const useVideoBlockYouTube = () => {
  
  useBlockMedia().initializeConsentCheck(document.querySelectorAll(".video__content--youtube"));

  document.addEventListener('YouTubeScriptLoaded', function(e) {
    // Stage 4: Initialize YouTube iframe API
    if (window.Cookiebot.consent.marketing && !!window.KnowitOptimizelyFramework.YouTube) {
      document.querySelectorAll(".video__content--youtube").forEach(element => {
        let blockElement = element as HTMLElement;

        // If this script is already initialized
        if (blockElement.dataset.initializedMedia === "true") {
          return;
        }

        blockElement.classList.remove("video__content--prevent-video");
        blockElement.classList.remove("video__content--show-video")

        // Set initialized attribute to prevent this script from running again
        blockElement.dataset.initializedMedia = "true";
      });

      window.KnowitOptimizelyFramework.YouTube.initialize();
    }
  });

  // When CookieBot consents are changed
  window.addEventListener('CookiebotOnAccept', function(e) {
    document.dispatchEvent(new CustomEvent("YouTubeRelatedScriptLoaded"));
  });

  // Tell other modules that this script is loaded
  document.dispatchEvent(new CustomEvent("YouTubeRelatedScriptLoaded"));

  // Stage 5: Add a YouTube-player and start playing when the user clicks on a video block
  const initializeYouTubeMediaBlocks = () => {
    document.querySelectorAll(".video__content--youtube").forEach(element => {
      let blockElement = element as HTMLElement;

      // If this script is already initialized
      if (blockElement.dataset.initializedMediaBlockEvents === "true") {
        return;
      }

      if (!!blockElement.querySelector(".video__image-wrapper")) {
        blockElement.addEventListener("click", () => {
          initializeVideoAndPlay(blockElement, true);
        }); 
      } else {
        initializeVideoAndPlay(blockElement, false);
      }

      blockElement.dataset.initializedMediaBlockEvents = "true";
    });
  }

  const onPlayerStateChange = (event: any, ytPlayerId: string | undefined) => {
    let blockElement = document.querySelector(`#${ytPlayerId}`)?.closest(".video__content");

    if (event.data == window.YT.PlayerState.PAUSED) {
      blockElement?.classList.remove("video__content--show-video");
    } else if (event.data == window.YT.PlayerState.PLAYING) {
      blockElement?.classList.remove("video__content--load-video");
      blockElement?.classList.add("video__content--show-video");
    }
  }

  const initializeVideoAndPlay = (blockElement: Element, autoPlay = false) => {
    if (blockElement instanceof HTMLElement && !!window.KnowitOptimizelyFramework.YouTube && window.Cookiebot?.consent?.marketing) {
      if (!blockElement.querySelector("iframe")) {
        blockElement?.classList.remove("video__content--show-video");
        blockElement.classList.add("video__content--load-video");
        const {videoid, containerid} = blockElement.dataset;
        window.KnowitOptimizelyFramework.YouTube.createPlayer(videoid, containerid, onPlayerStateChange, autoPlay);
      } else {
        window.KnowitOptimizelyFramework.YouTube.playYouTubeVideo(blockElement);
      }
      
      // If icon is present, remove it when the video starts playing
      if (!!blockElement.querySelector(".video__icon")) {
        blockElement.querySelector(".video__icon")?.remove();
      }
    }
  }
  
  return {
    initializeYouTubeMediaBlocks,
    initializeVideoAndPlay
  }
}


// This method is called from YouTube-api
window.onYouTubeIframeAPIReady = () => {
  useVideoBlockYouTube().initializeYouTubeMediaBlocks();
}